export const mergeSharingData = <T extends object>(
  defaults: T,
  overrides?: Partial<T>
): T => {
  const result = { ...defaults };

  if (overrides) {
    for (const key in overrides) {
      const value = overrides[key];
      if (value !== undefined) {
        result[key] = value;
      }
    }
  }

  return result;
};
